import { APIConfiguration } from '@savgroup-front-common/configuration';
import {
  COMMON_QUERY_PARAMS,
  MIME_TYPES,
  SUPPORTED_METHODS,
} from '@savgroup-front-common/constants/src/shared';
import {
  BackResponse,
  BackResponseFailure,
} from '@savgroup-front-common/types';

import { prepareResponseFailure } from '../../helpers';
import { apiCall } from '../../services';

import { SessionType } from './getFilesUploadLinksBySessionIdCommand';

const ENDPOINT = `${APIConfiguration.document}session/${COMMON_QUERY_PARAMS.ID}/attachments`;

export interface GetFilesDownloadLinksBySessionIdQueryArgs {
  sessionId: string;
}

interface GetFilesDownloadLinksBySessionIdQueryResponse {
  links: string[];
  type: SessionType;
  sessionId: string;
  allowedMimeTypes?: MIME_TYPES[];
  metaData?: string;
}

async function getFilesDownloadLinksBySessionIdQuery({
  sessionId,
}: GetFilesDownloadLinksBySessionIdQueryArgs): Promise<
  | BackResponse<GetFilesDownloadLinksBySessionIdQueryResponse>
  | BackResponseFailure
> {
  try {
    return await apiCall<
      BackResponse<GetFilesDownloadLinksBySessionIdQueryResponse>
    >(ENDPOINT.replaceAll(COMMON_QUERY_PARAMS.ID, sessionId), {
      method: SUPPORTED_METHODS.GET,
    });
  } catch (error) {
    return prepareResponseFailure(error);
  }
}

export default getFilesDownloadLinksBySessionIdQuery;
